import axios from 'axios'

// TODO: replace with 'https://api.carbon.network' when bridge module is available
const rootUrl =
  process.env.REACT_APP_CARBON_API_ENDPOINT || 'http://202.156.63.105:30002'

const CarbonAPI = axios.create({
  baseURL: `${rootUrl}`,
})

export default CarbonAPI
